import React, {useEffect, useState} from 'react';
import {NavLink, withRouter} from "react-router-dom";
import * as axios from "axios";
import {baseURL} from "../../api/api";
import style from './Search.module.css'
import {Container, Row} from "react-bootstrap";
import Preloader from "../common/Preloader/Preloader";

const SECTION_LABELS = {
    articles: 'Статьи',
    books: 'Учебные издания',
};

export const searchUrl = (q, sect = 'articles') =>
    `/результатпоиска?q=${encodeURIComponent(q)}&sect=${encodeURIComponent(sect)}`;

/** Запрос и раздел — из ?q=&sect=, а для старых ссылок — из /результатпоиска/:search/:sect. */
const readParams = (location, match) => {
    const params = new URLSearchParams(location.search);
    const q = (params.get('q') ?? match.params.search ?? '').trim();
    const sect = params.get('sect') || match.params.sect || 'articles';
    return {q, sect: SECTION_LABELS[sect] ? sect : 'articles'};
};

const Search = ({location, match, history}) => {
    const {q, sect} = readParams(location, match);

    const [input, setInput] = useState(q);
    const [inputSect, setInputSect] = useState(sect);
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [failed, setFailed] = useState(false);

    // Поле формы следует за адресом (переход «Назад», новый поиск с главной).
    useEffect(() => {
        setInput(q);
        setInputSect(sect);
    }, [q, sect]);

    useEffect(() => {
        if (!q) {
            setResults([]);
            return;
        }
        let cancelled = false;
        setLoading(true);
        setFailed(false);
        axios.get(baseURL + 'api/articlesearch', {params: {q, sect}})
            .then(response => {
                if (!cancelled) setResults(Array.isArray(response.data) ? response.data : []);
            })
            .catch(() => {
                if (!cancelled) setFailed(true);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [q, sect]);

    const onSubmit = (e) => {
        e.preventDefault();
        const value = input.trim();
        if (value) history.push(searchUrl(value, inputSect));
    };

    const otherSect = sect === 'articles' ? 'books' : 'articles';

    return (
        <div>
            <div className={'breadcrumdBottom'}>
                <Container>
                    <Row>
                        <div className={'breadcrumdCont'}>
                            <NavLink to={'/'}>
                                <div className={'breadcrumbTitle'}>eLibrary</div>
                            </NavLink>
                            <div className={'breadcrumbItem'}>Поиск</div>
                        </div>
                    </Row>
                </Container>
            </div>

            <div className={style.cont + ' container'}>
                <form className={style.form} onSubmit={onSubmit} role="search">
                    <input
                        type="search"
                        className="form-control"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Поиск по названию"
                        aria-label="Поиск по названию"
                    />
                    <select
                        className="custom-select"
                        value={inputSect}
                        onChange={(e) => setInputSect(e.target.value)}
                        aria-label="Где искать"
                    >
                        <option value="articles">в статьях</option>
                        <option value="books">в учебных изданиях</option>
                    </select>
                    <button type="submit" className={style.submit}>Искать</button>
                </form>

                {!q ? (
                    <p className={style.note}>Введите название или его часть.</p>
                ) : (
                    <h1 className={style.heading}>
                        {SECTION_LABELS[sect]} по запросу «{q}»
                        {!loading && !failed ? <span className={style.count}>найдено: {results.length}</span> : null}
                    </h1>
                )}

                {loading ? <Preloader/> : null}

                {failed ? (
                    <p className={style.note}>Не удалось выполнить поиск. Попробуйте ещё раз чуть позже.</p>
                ) : null}

                {q && !loading && !failed && results.length === 0 ? (
                    <div className={style.empty}>
                        <p>Ничего не найдено. Проверьте написание или сократите запрос до одного-двух слов.</p>
                        <NavLink to={searchUrl(q, otherSect)}>
                            Искать «{q}» в разделе «{SECTION_LABELS[otherSect]}»
                        </NavLink>
                    </div>
                ) : null}

                {!loading && sect === 'articles' ? results.map(item => (
                    <div key={item.id} className={style.item}>
                        <div className="text-secondary">Статья</div>
                        <NavLink to={'/журнал/статья/' + item.id}>{item.name}</NavLink>
                        <div className={style.meta}>
                            {item.udk ? <span>УДК: {item.udk}</span> : null}
                            {item.file_path ? (
                                <a target='_blank' rel='noopener noreferrer' href={baseURL + item.file_path}>Открыть PDF</a>
                            ) : null}
                        </div>
                    </div>
                )) : null}

                {!loading && sect === 'books' ? results.map(item => (
                    <div key={item.id} className={style.item}>
                        <div className="text-secondary">Учебное издание</div>
                        <NavLink to={'/учебныеиздания/учебник/' + item.id}>{item.name}</NavLink>
                        {item.publishers ? <div className={style.meta}><span>Издание: {item.publishers}</span></div> : null}
                    </div>
                )) : null}
            </div>
        </div>
    )
}
export default withRouter(Search);
